<template>
  <div class="top-right-cmp" style="margin-top: 10px;">
    <!--<dv-border-box-7 style="width: 90%; height: 80%; margin-top: 20px">-->
      <div class="chart-name1">
        当月已完成工单数量
        <dv-decoration-7 style="width:180px; height:20px; padding-top: 20px">
          <span style="color: #00c0ff; margin-left: 10px; margin-right: 10px; font-size: 26px">{{completedCurrentMonth}}</span>
        </dv-decoration-7>
      </div>
      <div class="chart-name">
        近30日工单完成数量趋势图
        <dv-decoration-3 style="width:200px;height:20px;" />
      </div>
      <dv-charts :option="option" />
    <!--</dv-border-box-7>-->
  </div>
</template>

<script>
export default {
  name: 'TopRightCmp',
  data () {
    return {
      lineId: undefined,
      completedCurrentMonth: 0,
      xAxisData: [],
      seriesData: [],
      option: {
        legend: {
          data: [
           /* {
              name: '收费系统',
              color: '#00baff'
            },
            {
              name: '监控系统',
              color: '#ff5ca9'
            }*/
          ],
          textStyle: {
            fill: '#fff'
          }
        },
        xAxis: {
          data: this.xAxisData,
          axisLine: {
            style: {
              stroke: '#999'
            }
          },
          axisLabel: {
            style: {
              fill: '#999'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          data: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            style: {
              stroke: '#999'
            }
          },
          axisLabel: {
            style: {
              fill: '#999'
            }
          },
          axisTick: {
            show: false
          },
          min: 0,
          max: 8
        },
        series: [
          {
            name: '收费系统',
            data: this.seriesData,
            type: 'bar',
            barStyle: {
              fill: 'rgba(0, 186, 255, 0.4)'
            }
          },
          {
            name: '监控系统',
            data: this.seriesData,
            type: 'line',
            lineStyle: {
              stroke: '#ff5ca9'
            },
            label: {
              show: true
            },
            linePoint: {
              radius: 4,
              style: {
                fill: '#ff5ca9',
                stroke: 'transparent'
              }
            },
          }
        ]
      }
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 30000);
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderCompletedCount',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      const max = Math.max.apply(null, data.dataList);
      this.completedCurrentMonth = data.completedCurrentMonth;
      this.updateChart(data.dateList, data.dataList, max);
    },

    updateChart(xAxisData, seriesData, max) {
      this.option = {
        legend: {
          data: [
            /* {
               name: '收费系统',
               color: '#00baff'
             },
             {
               name: '监控系统',
               color: '#ff5ca9'
             }*/
          ],
          textStyle: {
            fill: '#fff'
          }
        },
        xAxis: {
          data: xAxisData,
          axisLine: {
            style: {
              stroke: '#999'
            }
          },
          axisLabel: {
            style: {
              fill: '#999'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          data: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            style: {
              stroke: '#999'
            }
          },
          axisLabel: {
            style: {
              fill: '#999'
            }
          },
          axisTick: {
            show: false
          },
          min: 0,
          max: max + 2
        },
        series: [
          {
            name: '收费系统',
            data: seriesData,
            type: 'bar',
            barStyle: {
              fill: 'rgba(0, 186, 255, 0.4)'
            }
          },
          {
            name: '监控系统',
            data: seriesData,
            type: 'line',
            lineStyle: {
              stroke: '#ff5ca9'
            },
            label: {
              show: true
            },
            linePoint: {
              radius: 4,
              style: {
                fill: '#ff5ca9',
                stroke: 'transparent'
              }
            },
          }
        ]
      }
    }
  }
}
</script>

<style lang="less">

.top-right-cmp {
  width: 30%;
  box-sizing: border-box;
  position: absolute;
  height: calc(100% - 730px);
  left: 0px;
  top: 705px;
  flex-direction: column;

  .chart-name {
    position: absolute;
    right: 70px;
    text-align: right;
    font-size: 16px;
    top: 10px;
  }

  .chart-name1 {
    position: absolute;
    text-align: right;
    font-size: 20px;
    top: 10px;
    left: 70px;
  }
}




</style>
